module.exports = __webpack_public_path__ + "static/media/ive.2037e108.jpg";